import url from 'url';

import { ENV } from '../settings/env';

export const parsedUrl = url.parse(document.location.href, true);
export const extension = parsedUrl.hostname.split('.').slice(-1)[0].toLowerCase();
export const localePath = parsedUrl.pathname.substr(1).split('/')[1];
export const baseUrl = getBaseUrl();

export function localUrl(pathname, query, hash = '') {
  const urlObj = {
    ...parsedUrl,
    hash,
    pathname,
    query
  };
  delete urlObj.href;
  delete urlObj.path;
  delete urlObj.search;
  return url.format(urlObj);
}

export function getBaseUrl() {
  const urlObj = {
    hostname: parsedUrl.hostname,
    pathname: ['preProduction', 'production'].indexOf(ENV) === -1
      ? ''
      : 'store',
    port: parsedUrl.port,
    protocol: parsedUrl.protocol
  };
  return url.format(urlObj) + '/';
}



// WEBPACK FOOTER //
// ./src/services/url.js